// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/open-door-or-window.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/open-door-or-window/open-door-or-window.js';

mount([g0]);
